<template>
  <div v-if="uploaders.length" class="reg-uploader-global-status">
    <v-expansion-panels :value="$vuetify.breakpoint.xsOnly ? -1 : 0">
      <v-expansion-panel>
        <v-expansion-panel-header color="grey lighten-4">
          {{ $t('in_progress_uploads') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content class="no-padding-content">
          <v-list three-line light dense>
            <template v-for="(uploader, index) in uploaders">
              <v-divider v-if="index > 0" :key="'div' + index" />
              <v-list-item :key="uploader.thread">
                <v-list-item-content>
                  <v-list-item-title class="text-body-1">
                    {{ $tc('file_module.uploading_message', uploader.numFiles, {numFiles: uploader.numFiles}) }}
                    <span class="text-caption ml-1 grey--text">
                      {{ uploader.estimatedTime | formatHours(2) }}
                    </span>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <span class="text-caption">
                      {{ uploader.bytesUploaded | formatBytes }}
                      {{ $t('of') }}
                      {{ uploader.totalSize | formatBytes }} {{ $t('at_speed') }} {{ uploader.mbps | formatNumber }} Mbps
                    </span>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <v-progress-linear v-model="uploader.uploadProgress" :height="4" color="primary" />
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon
                         ripple
                         @click="onCancelClick(uploader)">
                    <v-icon color="grey lighten-1">
                      close
                    </v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'RegGlobalUploadStatus',
  computed: {
    uploaders() {
      return _.filter(this.$upload.watch.uploaders, uploader => {
        return uploader.started === true && uploader.silent !== true
      })
    }
  },
  methods: {
    onCancelClick(uploader) {
      this.$confirm({
        title: this.$t('warning'),
        message: this.$t('file_module.confirm_cancel_upload'),
        confirmText: this.$t('yes'),
        cancelText: this.$t('no')
      }).then((confirmed) => {
        if (!confirmed) return
        uploader.cancelAll()
      })
    }
  }
}
</script>

<style lang="scss">
.reg-uploader-global-status {
  position: fixed;
  display: flex;
  z-index: 1000;
  bottom: 0;
  left: 60px;
  right: auto;
  -webkit-transform: none;
  -ms-transform: none;
  transform: none;
  max-width: 350px !important;
  min-width: 250px !important;
  @media screen and (max-width: 600px) {
    left: 0;
    max-width: 100% !important;
    min-width: 100% !important;
  }

  .no-padding-content .v-expansion-panel-content__wrap {
    padding: 0px !important;
  }
}
</style>
